import { useEffect } from "react";
import { useLang } from "@/i18n/LanguageContext";

export function useSEO(page) {
  const { lang, translations } = useLang();
  useEffect(() => {
    const meta = translations.seo?.[page]?.[lang];
    if (!meta) return;
    document.title = meta.title;
    const el = document.querySelector('meta[name="description"]');
    if (el) el.setAttribute("content", meta.desc);
  }, [page, lang, translations]);
}

export default useSEO;
